import React from "react";
import { Button } from "@material-ui/core";
import { useDataApi } from "Shoothill.Core/Utils";
import { ApiResult } from "Shoothill.Components/Models";

export const User: React.FC = () => {
	const { doRequest } = useDataApi<ApiResult>();

	return (
		<div className="App">
			{/* <iframe
				className="apollo11"
				style={{ overflow: "hidden" }}
				allow="encrypted-media"
				allowFullScreen
				src="https://apollo11.shoothill.com"
			/> */}
			<iframe
				style={{ border: "none", overflow: "hidden", height: "90vh", width: "100%", display: "block" }}
				allowFullScreen
				src="https://apollo11.shoothill.com"
			/>
		</div>
	);
};
